import { IGoalReward } from "@interfaces/user/refs";
import { createContext, useContext } from "react";

export const GoalRewardContext = createContext<IGoalReward>(undefined as any);
export const GoalRewardProvider = GoalRewardContext.Provider;

export function useGoalRewardContext(): IGoalReward | undefined {
    return useContext(GoalRewardContext);
}